import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  NgZone,
} from '@angular/core';

import { CommonModule, Location } from '@angular/common'; // Asegúrate de importar CommonModule
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService } from '../../../core/services/alert/alert.service';
import { OrdersService } from '../../../core/services/orders/orders.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { LocalStorageService } from '../../../core/services/localStorage/local-storage.service';
import { TabsFormComponent } from './tabs-form/tabs-form.component';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';

interface Model {
  reference: string;
  name: string;
}

interface FileItem {
  file: File;
  selectOption: string;
  key: string;
}
@Component({
  selector: 'app-form-update-excel',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    NgSelectModule,
    FormsModule,
    TabsFormComponent,],
  templateUrl: './form-update-excel.component.html',
  styleUrl: './form-update-excel.component.css'
})
export class FormUpdateExcelComponent {

  @Output() backButtonClick = new EventEmitter<boolean>();
  @Output() import = new EventEmitter<any>();
  @Output() formSubmit = new EventEmitter<any>();

  @Input() orderData?: any; // Objeto opcional

  @Input() dataContainer?: any;

  @Input() document_buttons_chico = false;

  @Input() ladata: any = [];

  @Input() tab?: any;


  files: FileItem[] = [];

  isDragOver = false;

  showImportantDates = false;
  account_type: any = this.authStateService.getAccountType();
  form: FormGroup = this.fb.group({});
  draft = false;
  order_reference: string = '';
  /* client_reference: string = ''; */
  client: any = '';
  guarantee_reference: string = '';
  guarantee: any = '';
  back = '';
  brand_id_modal: any;
  searchParams: any = {};
  @Input() client_reference: any;
  //viene de la data
  selectTypes: any[] = [];

  newStage: string = '';
  title = '';
  activeForm = 'general';
  posiblesTabs: any[] = [
    'general',

  ];

  docFiles: any[] = [];

  stage?: any;
  rules: any = {};
  role: any;

  updatesTabs: any[] = [];

  helperStep = 1;
  //////////////////////////////////SI///////////////////////////////

  constructor(
    private fb: FormBuilder,
    private alertService: AlertService,
    private orderService: OrdersService,
    private location: Location,
    private localStorageService: LocalStorageService,
    private router: Router,
    private ngZone: NgZone,
    private authStateService: AuthStateService
  ) { }

  //////////////////////////////////NO///////////////////////////////

  ngOnChanges(changes: SimpleChanges) {
    this.refrescarFormulario();
    this.role = this.authStateService.getRole();
  }

  ngAfterViewInit() {
    this.form = this.fb.group({
      stage: ['draft', Validators.required],
    });
    this.refrescarFormulario();
  }


  setTitle() {
    this.title = this.orderData?.client?.name
      ? this.orderData?.client?.name +
      ' ' +
      (this.orderData?.client?.lastname
        ? this.orderData?.client?.lastname
        : '')
      : this.account_type === 'broker'
        ? this.orderData?.broker_reference
        : this.account_type === 'supplier'
          ? this.orderData?.supplier_reference
            ? this.orderData?.supplier_reference
            : this.orderData?.reference
          : this.orderData?.reference;
  }

  refrescarFormulario() {
    this.setTitle();
    if (this.posiblesTabs.includes(this.tab)) {
      if (this.activeForm != this.tab) {
        this.activeForm = this.tab;
      }
    }

    this.alertService.close();
  }

  goDocs() {
    this.activeForm = 'doc-order';
  }

  @Input() openedFromClients = false;
  @Output() closeOrderForm = new EventEmitter<void>();

  emitBackButtonClick() {
    const nuevaURL = this.location.path();
    const index = nuevaURL.indexOf('/');
    this.location.go(nuevaURL.substring(0, index));
    this.backButtonClick.emit(true);
  }



  refrescar() {
    this.alertService.loading('swal_messages.please_wait');
    this.orderService.getDataByReference(this.orderData.reference).subscribe({
      next: (data) => {
        this.orderData = data.data;
        this.refrescarFormulario();
        this.alertService.close();
      },
      error: (error) => {
        this.alertService.error(error.error).then((result) => {
          if (result.isConfirmed) {
          }
        });
      },
    });
  }


  onFileInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0]; // Toma solo el primer archivo

    if (file) {
      this.handleFileUpload(file); // Llama a la función para un solo archivo
    }
  }

  emitImport(reference: any) {
    this.import.emit(reference);
  }

  /**
   * Valida un archivo Excel antes de subirlo
   * @param file Archivo a validar
   * @returns true si el archivo es válido, false en caso contrario
   */
  private validateExcelFile(file: File): { valid: boolean; error?: string } {
    // 1. Validar extensión del archivo
    const allowedExtensions = ['.xlsx', '.xls', '.csv'];
    const fileName = file.name.toLowerCase();
    const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
    
    if (!hasValidExtension) {
      return { valid: false, error: 'swal_messages.invalid_file_extension_excel' };
    }

    // 2. Validar MIME type
    const allowedMimeTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/csv',
      'application/csv'
    ];
    
    // Algunos navegadores no detectan bien el MIME type de Excel, permitir vacío si la extensión es válida
    if (file.type && !allowedMimeTypes.includes(file.type)) {
      return { valid: false, error: 'swal_messages.invalid_file_type_excel' };
    }

    // 3. Validar tamaño del archivo (máximo 5MB para Excel)
    const maxSizeInBytes = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSizeInBytes) {
      return { valid: false, error: 'swal_messages.file_too_large_5mb' };
    }

    // 4. Validar tamaño mínimo (evitar archivos vacíos)
    if (file.size === 0) {
      return { valid: false, error: 'swal_messages.file_is_empty' };
    }

    return { valid: true };
  }

  /**
   * Sanitiza el nombre del archivo para evitar inyecciones
   * @param fileName Nombre del archivo original
   * @returns Nombre sanitizado
   */
  private sanitizeFileName(fileName: string): string {
    // Eliminar caracteres peligrosos y mantener solo alfanuméricos, guiones, puntos y guiones bajos
    return fileName.replace(/[^a-zA-Z0-9._-]/g, '_');
  }

  handleFileUpload(file: File): void {
    if (file) {
      // Validar el archivo antes de subirlo
      const validation = this.validateExcelFile(file);
      
      if (!validation.valid) {
        this.alertService.error(validation.error || 'swal_messages.invalid_file');
        return;
      }

      const formData = new FormData();
      formData.append('file', file);

      this.alertService.loading('swal_messages.please_wait');

      this.orderService.uploadExcel(formData).subscribe({
        next: (response) => {
          this.alertService.close();
          this.emitImport(response.data.reference);

        },
        error: (error) => {
          console.error('Error al subir el documento:', error);
          this.alertService.error(error.error);
        },
      });
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
    const droppedFile = event.dataTransfer?.files?.[0]; // Toma solo el primer archivo

    if (droppedFile) {
      this.handleFileUpload(droppedFile); // Llama a la función modificada para un solo archivo
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
  }

}
